import { combineReducers } from '@reduxjs/toolkit'
import init from './initSlice'

const reducer = combineReducers({
    init,
})

export default reducer
